import { Box, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const ModelSelector = ({ data, markersModels, setModel }) => {
  const { t } = useTranslation();

  return (
    <Box id="model" mb={2}>
      <InputLabel shrink>{t("/editor.gui.marker_shape")}</InputLabel>
      <Select
        value={data?.marker?.model ?? "pin"}
        onChange={(e) => setModel(e.target.value)}
      >
        {markersModels.map((model, i) => (
          <MenuItem key={i} value={model}>
            {t(`/editor.gui.model_${model}`)}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default ModelSelector; 